import FormController from 'controllers/form-controller';
import {
  deleteCompleteEventSources,
  findReferringCategory,
  sendTrackingEvent,
  trackCompleteEvent,
} from 'components/analytics/conversions/tracking';
import {
  JOIN_CLICK,
  LOGIN_COMPLETE,
  LOGIN_TRIGGERED,
} from 'components/analytics/conversions/constants/actions';

export default class LoginFormController extends FormController {
  connect() {
    super.connect();
    this.trackTriggerEvent();

    // Remove complete_event_sources cookie, in case
    // we're coming from a backend error
    deleteCompleteEventSources();
  }

  validateFields() {
    super.validateFields();

    if (this.formValid) {
      this.trackFormComplete();

      this.submit();

      trackCompleteEvent({
        action: LOGIN_COMPLETE,
        category: findReferringCategory(this.element),
        label: 'Sign_In-Email',
        dataLayerCompleteAttrs: [
          'email_address',
          'email_hash_md5',
          'email_hash_sha1',
          'sign_in_type',
          'name',
          'country',
          'postal_code',
          'team_owner_email',
          'team_seats',
          'multiple_logins',
        ],
      });
    } else {
      super.hideSpinner();
    }
  }

  trackCreate(event) {
    sendTrackingEvent({
      element: event.target,
      data: { action: JOIN_CLICK },
    });
  }

  // Sends Trigger events to Google Analytics based off of 'referring_conversions_category' param
  trackTriggerEvent() {
    const urlParameter = new URLSearchParams(window.location.search);
    const category = urlParameter.get('referring_conversions_category');
    const payload = {
      data: {
        category,
        action: LOGIN_TRIGGERED,
      },
    };

    if (category === 'Trigger-Reset_Password_Token_Invalid' || category === 'Trigger-Devise_Failure') {
      sendTrackingEvent(payload);
    }
  }
}
